import { FetchProps } from '@e3dc-react/shell/Hooks/AuthFetch/AuthFetch'
import { WeightedPricesModel, WeightedPricesDto } from './dto/weighted-prices.dto'

export type WeightedPriceResolution = 'quarter' | 'hour' | 'day' | 'month'

export const getWeightedPrices = async (
  authFetch: <T>(props: FetchProps) => Promise<T>,
  installationId: string,
  from: number,
  to: number,
  resolution: WeightedPriceResolution = 'quarter'
): Promise<WeightedPricesModel> => {
  const response = await authFetch<WeightedPricesDto>({
    endpoint: process.env.REACT_APP_INSTALLATIONS_ENDPOINT,
    path: `tariffs/${installationId}/weighted-price`,
    payload: { from, to, resolution },
  })

  const mappedResponse = mapWeightedPriceDtoToModel(response)

  return mappedResponse
}

const mapWeightedPriceDtoToModel = (dto: WeightedPricesDto): WeightedPricesModel => {
  return {
    summedEnergy: dto.sum,
    weightedAveragePrice: dto.price,
    weightedPrices: dto?.weightedPrices,
  }
}
